import { adminApi } from './ApiService';

class InvoiceService {
  // ── Invoices ───────────────────────────────────────────
  async listInvoices(params = {}) {
    return adminApi.get('/admin/invoices', params);
  }

  async getInvoice(id) {
    return adminApi.get(`/admin/invoices/${id}`);
  }

  async createInvoice(data) {
    return adminApi.post('/admin/invoices', data);
  }

  async updateInvoice(id, data) {
    return adminApi.patch(`/admin/invoices/${id}`, data);
  }

  async deleteInvoice(id) {
    return adminApi.delete(`/admin/invoices/${id}`);
  }

  async payInvoice(id, data = {}) {
    return adminApi.post(`/admin/invoices/${id}/pay`, data);
  }

  async cancelInvoice(id) {
    return adminApi.post(`/admin/invoices/${id}/cancel`, {});
  }

  /**
   * Batch-emit draft invoices for a period (monotributo ARCA).
   * @param {object} params - { month?: "2026-04", source?: "auto_device_registration"|"auto_saas_payment" }
   */
  async batchEmitInvoices(params = {}) {
    return adminApi.post('/admin/invoices/batch-emit', params);
  }

  async getNextNumber() {
    return adminApi.get('/admin/invoices/next-number');
  }

  async getSummary(params = {}) {
    return adminApi.get('/admin/invoices/summary', params);
  }

  // ── Quotes (Presupuestos) ──────────────────────────────
  async listQuotes(params = {}) {
    return adminApi.get('/admin/quotes', params);
  }

  async getQuote(id) {
    return adminApi.get(`/admin/quotes/${id}`);
  }

  async createQuote(data) {
    return adminApi.post('/admin/quotes', data);
  }

  async updateQuote(id, data) {
    return adminApi.patch(`/admin/quotes/${id}`, data);
  }

  async deleteQuote(id) {
    return adminApi.delete(`/admin/quotes/${id}`);
  }

  async sendQuote(id) {
    return adminApi.post(`/admin/quotes/${id}/send`, {});
  }

  async acceptQuote(id) {
    return adminApi.post(`/admin/quotes/${id}/accept`, {});
  }

  async rejectQuote(id) {
    return adminApi.post(`/admin/quotes/${id}/reject`, {});
  }

  async convertQuote(id) {
    return adminApi.post(`/admin/quotes/${id}/convert`, {});
  }

  async getNextQuoteNumber() {
    return adminApi.get('/admin/quotes/next-number');
  }

  // ── Credit Notes (Notas de Crédito) ────────────────────
  async listCreditNotes(params = {}) {
    return adminApi.get('/admin/credit-notes', params);
  }

  async getCreditNote(id) {
    return adminApi.get(`/admin/credit-notes/${id}`);
  }

  async createCreditNote(data) {
    return adminApi.post('/admin/credit-notes', data);
  }

  async issueCreditNote(id) {
    return adminApi.post(`/admin/credit-notes/${id}/issue`, {});
  }

  async deleteCreditNote(id) {
    return adminApi.delete(`/admin/credit-notes/${id}`);
  }

  // ── Tax Config ─────────────────────────────────────────
  async listTax() {
    return adminApi.get('/admin/tax');
  }

  async createTax(data) {
    return adminApi.post('/admin/tax', data);
  }

  async updateTax(id, data) {
    return adminApi.patch(`/admin/tax/${id}`, data);
  }

  async deleteTax(id) {
    return adminApi.delete(`/admin/tax/${id}`);
  }

  // ── Payment Receipts (Recibos de Pago) ───────────────────
  async listPaymentReceipts(invoiceId) {
    const params = invoiceId ? `?invoiceId=${invoiceId}` : '';
    return adminApi.get(`/admin/payment-receipts${params}`);
  }

  async createPaymentReceipt(data) {
    return adminApi.post('/admin/payment-receipts', data);
  }

  async deletePaymentReceipt(id) {
    return adminApi.delete(`/admin/payment-receipts/${id}`);
  }

  // ── Recurring Invoices (Facturación Recurrente) ──────────
  async listRecurring() {
    return adminApi.get('/admin/recurring-invoices');
  }

  async createRecurring(data) {
    return adminApi.post('/admin/recurring-invoices', data);
  }

  async updateRecurring(id, data) {
    return adminApi.patch(`/admin/recurring-invoices/${id}`, data);
  }

  async generateRecurring(id) {
    return adminApi.post(`/admin/recurring-invoices/${id}/generate`);
  }

  async deleteRecurring(id) {
    return adminApi.delete(`/admin/recurring-invoices/${id}`);
  }

  // ── AFIP ───────────────────────────────────────────────
  async getAfipConfig() {
    return adminApi.get('/admin/afip/config');
  }

  async saveAfipConfig(data) {
    return adminApi.post('/admin/afip/config', data);
  }

  async validateAfipInvoice(invoiceId) {
    return adminApi.post('/admin/afip/validate', { invoiceId });
  }
}

export default new InvoiceService();
